import { Component, OnInit } from '@angular/core';
import { SUPPORT_EMAIL } from 'src/app/constants/emailAndLinks';
import { IMAGES } from 'src/app/constants/imagePath';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  standalone: false
})
export class PrivacyPolicyComponent implements OnInit {
  Images = IMAGES;
  SupportEmail = SUPPORT_EMAIL;
  
  constructor() { }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }

}
